import { SHOPIFY_APP_STORE_URL } from 'constants/shopify'

// Where a Shopify tile on the Integrations page (/sources/add) sends the merchant.
//
// Pure logic — no JSX, no navigation, no module side-effects — so it can be unit-tested
// directly; AddSource wires in the real navigation. Same reasoning as shopifyStoreSwitch.ts.
//
// Extracted because the destination is load-bearing and easy to break in passing. The
// public tile used to point at /billing/products, where a plan click has no ?shop= context
// and therefore no store to charge, so it dead-ended on the "Shop details required" modal.
// The tests next to this file pin that it never points back there.

export const SHOPIFY_PUBLIC_SERVICE_ID = 'shopify'
export const SHOPIFY_PRIVATE_APP_SERVICE_ID = 'shopify_private_app'

export type ShopifyTileDestination =
  // Leaves the app for the App Store listing, behind a confirmation modal: installing is
  // the only way to obtain the shop domain + OAuth grant that Shopify billing requires.
  | { kind: 'app-store'; url: string }
  // Stays in the app: the private/custom app is connected with credentials the merchant
  // creates themselves on dev.shopify.com, so there is nothing to install from the listing.
  | { kind: 'credentials-form'; path: string }

/**
 * The destination for a Shopify tile, or `null` when the service is not a Shopify tile
 * (callers keep their own routing for everything else).
 */
export const shopifyTileDestination = (
  service: { id: string; uuid: string }
): ShopifyTileDestination | null => {
  switch (service.id) {
    case SHOPIFY_PUBLIC_SERVICE_ID:
      return { kind: 'app-store', url: SHOPIFY_APP_STORE_URL }
    case SHOPIFY_PRIVATE_APP_SERVICE_ID:
      // Relative path — AddSource pushes it onto the current /sources/add location.
      return { kind: 'credentials-form', path: `setup/${SHOPIFY_PRIVATE_APP_SERVICE_ID}/${service.uuid}` }
    default:
      return null
  }
}
